import Observer from 'common/scripts/observer';
import Popup from 'components/popup';
import PopupVideoControls from 'components/online';
import ShowMore from 'components/show-more';
import Slider from 'components/slider';

const observer = new Observer();

// переключение между фото и видео
const switchableWrappers = Array.from(document.querySelectorAll('.j-switchable'));

const initSwitch = (wrapper) => {
    const contentBlocks = Array.from(wrapper.querySelectorAll('.j-progress-content'));
    const switcher = wrapper.querySelector('.j-switch');
    const switcherInput = wrapper.querySelector('input.j-type-switch');

    // блокируем клик по переключалке, пока вся страница не прогрузится
    // window.addEventListener('DOMContentLoaded', () => {
    if (!switcher) {
        return;
    }

    switcher.classList.remove('is-loading');

    switcherInput.addEventListener('change', () => {
        contentBlocks.forEach((item) => {
            item.classList.toggle('is-active');
        });
    });
    // });
};

if (switchableWrappers.length) {
    switchableWrappers.forEach((wrapper) => {
        initSwitch(wrapper);
    });
}

// инициализация попапов фото и видео
const progressPopupBtn = Array.from(document.querySelectorAll('.j-progress-popup'));
const progressVideoPopupBtn = Array.from(document.querySelectorAll('.j-progress-popup-video-report'));

// Поключаем слайдер в попапе с ходом строительства
observer.subscribe('insetContentPopup', (openPopup) => {
    const sliderProgressWrap = openPopup.querySelector('.j-progress-slider');

    if (sliderProgressWrap) {
        const sliderProgress = new Slider();

        sliderProgress.init({
            slider       : sliderProgressWrap,
            dots         : true,
            thumbnails   : false,
            arrow        : true,
            counter      : true,
            arrowPosition: 'caption',
            modify       : 'theme_progress'
        });
    }
});

const initProgressPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть попап',
            template            : 'full',
            templateContent     : 'progress'
        };

        const popupProgress = new Popup(popupOptions);

        popupProgress.init();
    }
};

const initProgressVideoPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть попап',
            template            : 'full',
            templateContent     : 'progressVideo'
        };

        const popupProgress = new Popup(popupOptions);

        popupProgress.init();
    }
};

initProgressPopup(progressPopupBtn);
initProgressVideoPopup(progressVideoPopupBtn);

observer.subscribe('loadProgress', (reportList, reportsLoaded) => {
    const allProgressPopupBtn = Array.from(reportList.querySelectorAll('.j-progress-popup'));
    const allProgressPopupVideoBtn = Array.from(reportList.querySelectorAll('.j-progress-popup-video-report'));
    const loadedProgressPopupBtn = allProgressPopupBtn.slice(allProgressPopupBtn.length - reportsLoaded);
    const loadedProgressPopupVideoBtn = allProgressPopupVideoBtn.slice(allProgressPopupVideoBtn.length - reportsLoaded);

    initProgressPopup(loadedProgressPopupBtn);
    initProgressVideoPopup(loadedProgressPopupVideoBtn);
});

// eslint-disable-next-line no-warning-comments
// todo отрефакторить
const progressListClass = '.j-progress-list';
const progressLists = [...document.querySelectorAll(progressListClass)];

if (progressLists.length) {
    progressLists.forEach((list) => {
        const progressMore = list.querySelector('.j-progress-more-btn');
        const loadBtnCount = 0;

        observer.publish('loadProgress', list, list.childElementCount - loadBtnCount);

        if (progressMore) {
            const options = {
                button            : progressMore,
                listWrapper       : list,
                itemClass         : '.progress__article',
                nodesAfterLastItem: 1,
                url               : '/api/progress/'
            };

            new ShowMore(options).init();
        }
    });
}

// video controls
observer.subscribe('createPopup', (popup) => {
    const onlinePopup = popup.querySelector('.j-online-popup');

    if (onlinePopup) {
        const videoControls = new PopupVideoControls(onlinePopup);

        videoControls.init();
    }
});

// video popup
const videoPopupBtn = Array.from(document.querySelectorAll('.j-progress-popup-video'));

const initVideoPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть попап',
            template            : 'full',
            loadAfterOpen       : true
        };

        const popupProgress = new Popup(popupOptions);

        popupProgress.init();
    }
};

// film popup
const filmPopupBtn = Array.from(document.querySelectorAll('.j-popup-film'));

const initFilmPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть попап',
            template            : 'full',
            loadAfterOpen       : true
        };

        const popupFilm = new Popup(popupOptions);

        popupFilm.init();
    }
};

initVideoPopup(videoPopupBtn);
initFilmPopup(filmPopupBtn);
